export default __webpack_public_path__ + "static/media/background-video.9cd99ea6.mp4";